import { StUserLegacyService } from '@stilingue/st-user-legacy-service';
import gateway from './Gateway';
import serviceVersion from './service-version';

export default new StUserLegacyService(gateway, serviceVersion);
